import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Checkmark',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("polyline", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", points: "20,6.5 9,17.5 4,12.5" }
      })]
    );
  }
};